import { Component, OnDestroy, OnInit } from '@angular/core';
import { CFreeText } from '@models/imported/SagaSchema/CFreeText';
import { CacheService } from '@services/cache/cache.service';
import { filter, Subscription } from 'rxjs';
import { CallcardComponentCard } from '../callcard-component-card';

@Component({
  selector: 'app-callcard-cevents-card',
  templateUrl: './callcard-cevents-card.component.html',
  styleUrls: ['./callcard-cevents-card.component.scss']
})
export class CallcardCeventsCardComponent extends CallcardComponentCard implements OnInit, OnDestroy {
  get rLong(): string[] {
    return this.callcard.event.rLong.split('\r\n');
  }

  isPriority: boolean = false;

  private freeTexts: CFreeText[];
  private cacheSub: Subscription;

  constructor(private cacheService: CacheService) {
    super();
  }

  ngOnInit() {
    this.freeTexts = this.callcard.component<CFreeText>(CFreeText);

    this.cacheSub = this.cacheService
      .listenForChange(CFreeText)
      .pipe(filter(cacheEvent => (cacheEvent.object as CFreeText).CallCardId === this.callcard.ObjGuid))
      .subscribe(() => this.refreshPriority());

    this.refreshPriority();
  }

  private refreshPriority() {
    this.freeTexts.sort((a, b) => a.CreatedUTC.getTime() - b.CreatedUTC.getTime());
    const priorityTextStamps: CFreeText[] = this.freeTexts.filter(freetext => freetext.FreeTextType == 102);
    this.isPriority = priorityTextStamps.length ? priorityTextStamps[priorityTextStamps.length - 1].Text == '1' : false;
  }

  ngOnDestroy() {
    this.cacheSub?.unsubscribe();
  }
}
